import moment from 'moment';
import { getDistanceByPoint } from '@/js/map/tool';
import {
    apiAttractions,
    apiEvents,
    apiRivers,
    apiMappings,
    apiTcData,
    apiTcTourData,
    apiGetOpenApiQrcodes,
} from '@/plugin/api';
import { dataList as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        attractionList: [],
        eventList: [],
        newsList: [],
        riverList: [],
        qrcodesList: [],
        dataLoading: false,
        newsLoading: false,
        mappings: {},
    },
    getters: {
        // eslint-disable-next-line no-unused-vars
        /**
         * @returns 附近QRCode列表
         */
        nearbyQrcodesList: (state, getters, rootState, rootGetters) => {
            let nearbyList = [...state.qrcodesList];
            // 使用者位置在有效範圍內
            if (rootGetters['userData/showDistance']) {
                // 計算距離使用者到景點距離
                nearbyList = state.qrcodesList.map((spot) => {
                    const distance = parseInt(
                        getDistanceByPoint(rootState.userData.currentPosition, [
                            +spot.lon,
                            +spot.lat,
                        ]),
                        10,
                    );
                    return { ...spot, distance };
                });
                // 依距離作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'distance';
                    return a[sortColumn] - b[sortColumn];
                });
            } else {
                // 依id作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'id';
                    return `${a[sortColumn]}`.localeCompare(b[sortColumn]);
                });
            }
            return nearbyList;
        },
        // eslint-disable-next-line no-unused-vars
        /**
         * @returns 附近景點列表
         */
        nearbyAttractionList: (state, getters, rootState, rootGetters) => {
            let nearbyList = [...state.attractionList];
            // 使用者位置在有效範圍內
            if (rootGetters['userData/showDistance']) {
                // 計算距離使用者到景點距離
                nearbyList = state.attractionList.map((spot) => {
                    const distance = parseInt(
                        getDistanceByPoint(rootState.userData.currentPosition, [
                            +spot.lon,
                            +spot.lat,
                        ]),
                        10,
                    );
                    return { ...spot, distance };
                });
                // 依距離作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'distance';
                    return a[sortColumn] - b[sortColumn];
                });
            } else {
                // 依id作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'id';
                    return `${a[sortColumn]}`.localeCompare(b[sortColumn]);
                });
            }

            return nearbyList;
        },
        // eslint-disable-next-line no-unused-vars
        /**
         * @returns 附近活動列表
         */
        nearbyEventList: (state, getters, rootState, rootGetters) => {
            let nearbyList = [...state.eventList];
            // 使用者位置在有效範圍內
            if (rootGetters['userData/showDistance']) {
                // 計算距離使用者到景點距離
                nearbyList = state.eventList.map((spot) => {
                    const distance = parseInt(
                        getDistanceByPoint(rootState.userData.currentPosition, [
                            +spot.lon,
                            +spot.lat,
                        ]),
                        10,
                    );
                    return { ...spot, distance };
                });
                // 依距離作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'distance';
                    return a[sortColumn] - b[sortColumn];
                });
            } else {
                // 依id作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'id';
                    return `${a[sortColumn]}`.localeCompare(b[sortColumn]);
                });
            }

            return nearbyList;
        },
        // eslint-disable-next-line no-unused-vars
        /**
         * @returns 附近活動列表
         */
        nearbyRiverList: (state, getters, rootState, rootGetters) => {
            let nearbyList = [...state.riverList];
            // 使用者位置在有效範圍內
            if (rootGetters['userData/showDistance']) {
                // 計算距離使用者到景點距離
                nearbyList = state.riverList.map((spot) => {
                    const distance = parseInt(
                        getDistanceByPoint(rootState.userData.currentPosition, [
                            +spot.lon,
                            +spot.lat,
                        ]),
                        10,
                    );
                    return { ...spot, distance };
                });
                // 依距離作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'distance';
                    return a[sortColumn] - b[sortColumn];
                });
            } else {
                // // 依id作排序;
                // nearbyList.sort((a, b) => {
                //   const sortColumn = "id";
                //   return ("" + a[sortColumn]).localeCompare(b[sortColumn]);
                // });
            }

            return nearbyList;
        },
    },
    actions: {
        async setAttractionList({ commit }) {
            const result = await apiAttractions({ pageSize: 1000 }).then(
                (res) => res.data.data,
            );
            commit(types.setAttractionList, result);
        },
        async setEventList({ commit }) {
            const result = await apiEvents().then((res) => res.data.data);
            commit(types.setEventList, result);
        },
        async setRiverList({ commit }) {
            const result = await apiRivers().then((res) => res.data.data);
            commit(types.setRiverList, result);
        },
        async setNewsList({ commit }) {
            const nowDate = new Date();
            const endDate = moment(nowDate).format('YYYY-MM-DD');
            let startDate = new Date();
            startDate.setFullYear(startDate.getFullYear() - 1);
            startDate = moment(startDate).format('YYYY-MM-DD');
            const rows = 100;
            const regexp = /綠川|柳川|東大溪|旱溪排水|惠來溪|潮洋溪|筏子溪/g;
            commit(types.setNewsLoading, true);
            const result = await Promise.all([
                apiTcTourData({
                    contentId: 9962,
                    startDate,
                    endDate,
                    rows,
                }).catch(() => ({ data: { Children: [] } })),
                apiTcData({
                    contentId: 28240,
                    startDate,
                    endDate,
                    rows,
                }).catch(() => ({ data: { Children: [] } })),
                apiTcData({
                    contentId: 16658,
                    startDate,
                    endDate,
                    rows,
                }).catch(() => ({ data: { Children: [] } })),
            ]).then((res) => [
                ...res[0].data.Children.filter(
                    (item) => item.Name.match(regexp)
                            || item.Properties.find(
                                (p) => p.alias === 'content',
                            ).value.match(regexp),
                ).map((item) => ({
                    ...item,
                    source: '臺中市政府-市政新聞',
                })),
                ...res[1].data.Children.filter(
                    (item) => item.Name.match(regexp)
                            || item.Properties.find(
                                (p) => p.alias === 'content',
                            ).value.match(regexp),
                ).map((item) => ({
                    ...item,
                    source: '臺中市政府水利局-最新消息',
                })),
                ...res[2].data.Children.filter(
                    (item) => item.Name.match(regexp)
                            || item.Properties.find(
                                (p) => p.alias === 'memo',
                            ).value.match(regexp),
                ).map((item) => ({
                    ...item,
                    source: '臺中市觀光旅遊局-最新消息',
                })),
            ].sort((a, b) => {
                const sortCol = 'CreateDate';
                return new Date(b[sortCol]) - new Date(a[sortCol]);
            }));
            commit(types.setNewsLoading, false);
            commit(types.setNewsList, result);
        },
        setDataLoading({ commit }, data) {
            commit(types.setDataLoading, data);
        },
        async setMappings({ commit }) {
            const result = await apiMappings().then((res) => res.data);
            commit(types.setMappings, result);
        },
        async setQrcodesList({ commit }) {
            const result = await apiGetOpenApiQrcodes().then((res) => res.data.data.map((d) => ({ ...d, lon: d.x, lat: d.y })));
            commit(types.setQrcodesList, result);
        },
    },
    mutations: {
        [types.setAttractionList]: (state, data) => {
            state.attractionList = data.map((item) => ({
                ...item,
                lat: +item.latitude,
                lon: +item.longitude,
                name: item.name,
                id: item.attractionId,
            }));
        },
        [types.setEventList]: (state, data) => {
            state.eventList = data.map((item) => ({
                ...item,
                lat: +item.latitude,
                lon: +item.longitude,
                name: item.subject,
                id: item.eventId,
            }));
        },
        [types.setRiverList]: (state, data) => {
            state.riverList = data.map((item) => ({
                ...item,
                lat: +item.latitude,
                lon: +item.longitude,
                name: item.name,
                id: item.riverId,
            }));
        },
        [types.setNewsList]: (state, data) => {
            state.newsList = data.map((item) => ({
                ...item,
                name: item.Name,
                id: item.Id,
                startDate: item.CreateDate,
            }));
        },
        [types.setNewsLoading]: (state, data) => {
            state.newsLoading = data;
        },
        [types.setDataLoading]: (state, data) => {
            state.dataLoading = data;
        },
        [types.setMappings]: (state, data) => {
            state.mappings = data;
        },
        [types.setQrcodesList]: (state, data) => {
            state.qrcodesList = data;
        },
    },
};
